module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABICAMAAABiM0N1AAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMA378QIO+AQKBfzzCQcG9Qr1qAp3kAAADvSURBVFjD7ZbtCoMwDEVNmrZp68f6/i87mAhm6tQgg82cv8KhjfeGNoZhfBnXI5wE04onQlUAZeGpSqL0EGhF3glRqmqCEGW9CIWo6vFXierviAIVho9DCVS6fVE3xiFvabB/BafbFU35Krx2mDZOzTwgmqAE73eaPh4QyaAOj9mdRKvC/rCZRAkZxGFGXHvo93OUPczYC03EwzmCRJv7L+RzgeRVVWz9+WQvFqkbUFkRYJrfyeu6JgcfUVdaOXgK+S/WiIlMZKJbifxVIrzq6Rf0oiREDrQeaCRFOSVPQqN+sufSLEmMJ+HYGIZxe54BYp2VaaPRXgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email_bondo.png
// module id = RWi5
// module chunks = 1